import { Heading1, theme } from '@ovotech/element-v5';
import styled from 'styled-components';

export const StyledHeading1 = styled(Heading1)`
  margin-top: 2.8rem !important;
  color: ${theme.color.brand.onBrand};
`;
